import { render, staticRenderFns } from "./Tourist.vue?vue&type=template&id=113d1c88&scoped=true"
import script from "./Tourist.vue?vue&type=script&lang=js"
export * from "./Tourist.vue?vue&type=script&lang=js"
import style0 from "./Tourist.vue?vue&type=style&index=0&id=113d1c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d1c88",
  null
  
)

export default component.exports